/**
 * Enum of asset types for a VistaAsset.
 * @readonly
 * @enum {string}
 */
export var AssetType;
(function (AssetType) {
    AssetType["Original"] = "Original";
    AssetType["Print"] = "Print";
    AssetType["WebPreview"] = "WebPreview";
    AssetType["Thumb"] = "Thumb";
    AssetType["BackgroundKnockout"] = "BackgroundKnockout";
    AssetType["Embroidery"] = "Embroidery";
    AssetType["Monochrome"] = "Monochrome";
    AssetType["Sharpened"] = "Sharpened";
    AssetType["Segmented"] = "Segmented";
    AssetType["ImageInfo"] = "ImageInfo";
    AssetType["Embroiderify"] = "Embroiderify";
    AssetType["InvertColor"] = "InvertColor";
    AssetType["Sepia"] = "Sepia";
    AssetType["GreyScale"] = "Greyscale";
    AssetType["BackgroundRemoved"] = "BackgroundRemoved";
    AssetType["Segmentize"] = "segmentize";
})(AssetType || (AssetType = {}));
/**
 * Enum for Vista sub-brands.
 * @readonly
 * @enum {string}
 */
export var SubBrands;
(function (SubBrands) {
    SubBrands["VistaPrint"] = "VistaPrint";
    SubBrands["VistaCreate"] = "VistaCreate";
    SubBrands["Vista99D"] = "99Designs";
})(SubBrands || (SubBrands = {}));
/**
 * Tenants enum for default Vista tenants.
 * @readonly
 * @enum {string} Includes Vistaprint, VistaCreate, Vista99D, and VistaNonProd.
 */
export var Tenants;
(function (Tenants) {
    Tenants["VistaPrint"] = "wHqiv8SHZWp8fdGHeZ4Sp";
    Tenants["VistaCreate"] = "hJOHoP_bULB0KfG6vHZ3v";
    Tenants["Vista99D"] = "_lEO6aD8lq02u6QqsyZ_H";
    Tenants["VistaNonProd"] = "ol-ir4t7uFycQjunJdgCR";
    Tenants["VistaLogoMaker"] = "Qpf_04-CVu6JXKFddVYMe";
    Tenants["VistaLogoMakerNonProd"] = "X1MpaTDXiz8tdTiWGjqz_";
    Tenants["VistaCareSupport"] = "JqzyMexb118PYH7BJBqKY";
})(Tenants || (Tenants = {}));
/**
 * SDKErrorTypes enum holds predefined error messages used across the SDK.
 */
export var SDKErrorTypes;
(function (SDKErrorTypes) {
    SDKErrorTypes["ValidRouteError"] = "is not a valid route";
    SDKErrorTypes["VariantCreationError"] = "unable to create variant for UMS assets.";
    SDKErrorTypes["DataFindingError"] = "cannot find data parent asset";
    SDKErrorTypes["AssetIdNotFoundError"] = "asset id not found";
    SDKErrorTypes["ValidPageNoError"] = "is not a valid page number";
    SDKErrorTypes["ImageInfoError"] = "Image info not found";
    SDKErrorTypes["AssetNotFoundError"] = "cannot find asset";
    SDKErrorTypes["UrlGenerateError"] = "cannot generate the url";
    SDKErrorTypes["SingleAssetFetchError"] = "unable to fetch single asset";
    SDKErrorTypes["FileUploadError"] = "Invalid file uploaded";
    SDKErrorTypes["PreSignedUrlFailedError"] = "Unable to generate pre-signed url.";
})(SDKErrorTypes || (SDKErrorTypes = {}));
export { AssetStoreFetchStatusType, AssetStatusType, } from '@design-stack-ct/assets-sdk';
//# sourceMappingURL=types.js.map